import { DefaultRootStateProps } from 'types';
import * as actionTypes from '../actions';

export const initialState: DefaultRootStateProps['formBuilder'] = {
  name: '',
  nameFrench: '',
  description: '',
  descriptionFrench: '',
  template: '',
  lng: [],
  items: [],
  templateAvailableTo: {
    provider: false,
    providerAdministratorS: false,
    providerAdministratorD: false,
    administrator: false
  },
  type: '',
  currentStep: 0,
  steps: [
    {
      title: 'Title',
      titleFrench: 'Titre',
      items: []
    }
  ],
  formId: '',
  templateId: '',
  scoreBased: false,
  defaultStepName: '',
  defaultStepNameFrench: '',
  isForNotes: false,
  documentId: ''
};

const formBuilderReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case actionTypes.SET_CREATE_FORM_FIELDS:
      return {
        ...state,
        name: action.payload?.name,
        nameFrench: action.payload?.nameFrench,
        defaultStepName: action.payload?.defaultStepName,
        defaultStepNameFrench: action.payload?.defaultStepNameFrench,
        description: action.payload?.description,
        descriptionFrench: action.payload?.descriptionFrench,
        template: action.payload?.template,
        lng: action.payload?.lng,
        templateAvailableTo: {
          providerAdministratorS: action.payload?.templateAvailableTo?.providerAdministratorS,
          providerAdministratorD: action.payload?.templateAvailableTo?.providerAdministratorD,
          provider: action.payload?.templateAvailableTo?.provider,
          administrator: action.payload?.templateAvailableTo?.administrator
        },
        type: action.payload?.type,
        isForNotes: action.payload?.isForNotes
      };

    case actionTypes.SET_DOCUMENT_ID:
      return {
        ...state,
        documentId: action.payload
      };
    case actionTypes.SET_ITEMS:
      return {
        ...state,
        items: action.payload
      };
    case actionTypes.SET_STEPS:
      return {
        ...state,
        steps: action.payload
      };
    case actionTypes.SET_CURRENT_STEP:
      return {
        ...state,
        currentStep: action.payload
      };
    case actionTypes.RESET_FIELDS: {
      return {
        ...state,
        name: '',
        nameFrench: '',
        defaultStepName: '',
        defaultStepNameFrench: '',
        description: '',
        descriptionFrench: '',
        template: '',
        lng: '',
        items: [],
        templateAvailableTo: {
          providerAdministratorS: false,
          provider: false,
          providerAdministratorD: false,
          administrator: false
        },
        type: '',
        currentStep: 0,
        steps: [
          {
            title: 'Title',
            titleFrench: 'Titre',
            items: []
          }
        ],
        formId: '',
        templateId: '',
        scoreBased: false,
        isForNotes: false,
        documentId: ''
      };
    }
    case actionTypes.SET_FORM_ID: {
      return {
        ...state,
        formId: action.payload
      };
    }
    case actionTypes.SET_TEMPLATE_ID: {
      return {
        ...state,
        templateId: action.payload
      };
    }
    case actionTypes.RESET_FORM_ID: {
      return {
        ...state,
        formId: ''
      };
    }
    case actionTypes.RESET_TEMPLATE_ID: {
      return {
        ...state,
        templateId: ''
      };
    }
    case actionTypes.SET_LNG: {
      return {
        ...state,
        lng: action.payload
      };
    }
    case actionTypes.SET_DEFAULT_STEP_NAME: {
      return { ...state, defaultStepName: action.payload };
    }
    case actionTypes.SET_DEFAULT_STEP_NAME_FRENCH: {
      return { ...state, defaultStepNameFrench: action.payload };
    }
    default:
      return state;
  }
};

export default formBuilderReducer;
